export default "__VITE_ASSET__CKGpXwJU__"